import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DONATE } from "@/constants/testIds";

export function DonorInfoForm({ name, email, amount, frequency, loading, onNameChange, onEmailChange, onSubmit }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-sm p-6 sm:p-8 space-y-4">
      <div>
        <Label htmlFor="donorName" className="text-zinc-500 text-xs uppercase tracking-wide">Name (optional)</Label>
        <Input id="donorName" value={name} onChange={(e) => onNameChange(e.target.value)} data-testid={DONATE.nameInput}
          className="bg-white border-zinc-300 text-zinc-950 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none mt-1" />
      </div>
      <div>
        <Label htmlFor="donorEmail" className="text-zinc-500 text-xs uppercase tracking-wide">Email (for a receipt and updates)</Label>
        <Input id="donorEmail" type="email" value={email} onChange={(e) => onEmailChange(e.target.value)} data-testid={DONATE.emailInput}
          className="bg-white border-zinc-300 text-zinc-950 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none mt-1" />
        <p className="text-xs text-zinc-500 mt-1.5">By providing your email, you agree to receive updates from BBAP. Unsubscribe anytime.</p>
      </div>
      <Button
        onClick={onSubmit} disabled={loading} data-testid={DONATE.donateButton}
        className="w-full bg-[#1E3A6E] text-white font-medium rounded-none hover:bg-zinc-950 hover:shadow-[0px_4px_0px_0px_#4FD1C5] py-6"
      >
        {loading ? "Redirecting to secure checkout..." : `Donate $${amount || 0}${frequency === "monthly" ? "/month" : ""}`}
      </Button>
      <p className="text-xs text-zinc-400 text-center">Payments are securely processed by Stripe.</p>
    </div>
  );
}
